import React from 'react';
import '../../styles/OfficialDocumentation.css';
import { FaFileAlt } from 'react-icons/fa'; // Example icon

function OfficialDocumentation() {
  return (
    <div className="official-documentation">
      <h2>OFFICIAL DOCUMENTATION</h2>
      <div className="documentation-grid">
        <div className="document-card">
          <div className="card-icon"><FaFileAlt size={50} color="#00bcd4" /></div>
          <h3>Member Transfer Agreements</h3>
          {/* Add link or description if needed */}
        </div>
        <div className="document-card">
          <div className="card-icon"><FaFileAlt size={50} color="#ff9800" /></div>
          <h3>Membership Agreements</h3>
          {/* Add link or description if needed */}
        </div>
        <div className="document-card">
          <div className="card-icon"><FaFileAlt size={50} color="#3f51b5" /></div>
          <h3>Other Group Legal Agreements</h3>
          {/* Add link or description if needed */}
        </div>
      </div>
    </div>
  );
}

export default OfficialDocumentation;